<template>
    <div>
        <dx-grid
            url="contactUs"
            :columns="columns"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"></dx-grid>
    </div>
</template>

<script>
import moment from "moment";
import { getDomain } from "../utils/helpers.js";

export default {
    data: () => ({
        title: "Contact Us",
        columns: [
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Email",
                field: "email",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "CC",
                field: "cc",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Account ID",
                field: "accountID",
                link: "Account View",
                template: "link-action-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Date",
                field: "received",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(
                    moment()
                        .subtract(1, "month")
                        .add(1, "day")
                ),
                selectedFilterOperation: ">=",
                visible: true
            },
            {
                label: "Category",
                field: "category",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Message",
                field: "message",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Submit From URL",
                field: "submitFromURL",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            },
            {
                label: "Phone",
                field: "phone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null
            }
        ]
    }),
    created() {
        this.columns.find(
            (c) => c.field == "accountID"
        ).linkAction = this.onRowClicked;
    },
    methods: {
        onRowClicked(row) {
            this.$router.push({
                name: "Account View",
                params: {
                    id: row.accountID,
                },
                query: {
                    goToContactUsSection: true,
                },
            });
        }
    }
};
</script>
<style></style>
